<script setup>
  import { onMounted, ref, watch } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import { storeToRefs } from "pinia";
  import ThreePanePage from "@templates/ThreePanePage";
  import CreativeList from "@/components/MCampaign/Creatives/CreativeList.vue";
  import CreativeEdit from "@/components/MCampaign/Creatives/CreativeEdit/CreativeEdit.vue";
  import CreativePreview from "@/components/MCampaign/Creatives/CreativePreview.vue";
  import { useMCreativesStore } from "@stores/mCreatives";
  import { useSurveysStore } from "@stores/surveys";
  import { useCreativesDependencies } from "@composables/useCreativesDependencies";
  import { useUnsavedChangesGuard } from "@/utils/composables/useUnsavedChangesGuard";
  import { useMCampaignUnsavedChanges } from "@/utils/composables/useMCampaignUnsavedChanges";

  const route = useRoute();
  const router = useRouter();

  const { getSurveysLight } = useSurveysStore();

  const mCreativesStore = useMCreativesStore();
  const { creatives, selectedMCreative } = storeToRefs(mCreativesStore);
  const { selectCreative } = mCreativesStore;

  const { loadCreativeAssets } = useCreativesDependencies();

  const isCreativeRestored = ref(false);

  const syncCreativeQuery = (token) => {
    if (!isCreativeRestored.value || !token || token === route.query.creative) return;
    router.replace({ query: { ...route.query, creative: token } });
  };

  useUnsavedChangesGuard(useMCampaignUnsavedChanges().hasUnsavedChanges);

  onMounted(async () => {
    await Promise.all([loadCreativeAssets(), getSurveysLight(1, null)]);

    const requestedIndex = creatives.value.findIndex((creative) => creative.token === route.query.creative);
    selectCreative(Math.max(requestedIndex, 0));
    isCreativeRestored.value = true;
    syncCreativeQuery(selectedMCreative.value?.token);
  });

  watch(() => selectedMCreative.value?.token, syncCreativeQuery);
</script>

<template>
  <ThreePanePage data-cy="master-campaign-creatives-page">
    <template #left>
      <CreativeList />
    </template>
    <template #center>
      <CreativeEdit />
    </template>
    <template #right>
      <CreativePreview />
    </template>
  </ThreePanePage>
</template>
